"use client"

import { cn } from "../../lib/utils"

export interface VideoPlayerProps {
  src: string
  poster?: string
  className?: string
}

export const VideoPlayer = ({ src, poster, className }: VideoPlayerProps) => {
  return (
    <video
      src={src}
      poster={poster}
      controls
      controlsList="nodownload"
      playsInline
      className={cn("max-w-full rounded-md border border-border", className)}
    />
  )
}

VideoPlayer.displayName = "VideoPlayer"
